import { type AppLocale, parseLocaleAllowlist, resolveDefaultLocale } from './locales';
import type { SupportedLanguage } from '@/libs/sdk/api';

// Injected by Vite `define` at build time (see vite.config.ts). Changes every
// build so the i18n ?v= cache-bust query actually invalidates on each deploy.
declare const __I18N_BUILD_ID__: string;

// Tenant locale allowlist (VITE_LOCALES="zh-hk,en"); unset = every locale.
const APP_LOCALES = parseLocaleAllowlist(import.meta.env.VITE_LOCALES);

export const APP_I18N: {
  defaultLocale: SupportedLanguage;
  version: string;
  onlineVersion: string;
  locales: AppLocale[];
} = {
  defaultLocale: resolveDefaultLocale(import.meta.env.VITE_DEFAULT_LOCALE, APP_LOCALES),
  version: typeof __I18N_BUILD_ID__ !== 'undefined' ? __I18N_BUILD_ID__ : '1.0.0',
  onlineVersion: '1.0.0',
  locales: APP_LOCALES,
};
